import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.3 4.2H6.7c-.5 0-.9.3-.9.8v3.3a4.2 4.2 0 0 0 8.4 0V5c0-.5-.4-.8-.9-.8M6.7 2.5A2.5 2.5 0 0 0 4.2 5v3.3a5.8 5.8 0 1 0 11.6 0V5c0-1.4-1-2.5-2.5-2.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M.8 6.7C.8 5.3 2 4.2 3.3 4.2h2.5v6.6H4.2A3.3 3.3 0 0 1 .8 7.5zm2.5-.9h.9v3.4c-1 0-1.7-.8-1.7-1.7v-.8c0-.5.4-.9.8-.9m15.9.9c0-1.4-1.2-2.5-2.5-2.5h-2.5v6.6h1.6c1.9 0 3.4-1.5 3.4-3.3zm-2.5-.9h-.9v3.4c1 0 1.7-.8 1.7-1.7v-.8c0-.5-.4-.9-.8-.9",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M10 12.5c-.5 0-.8.4-.8.8v2.5H7.5a.8.8 0 0 0 0 1.7h5a.8.8 0 1 0 0-1.7h-1.7v-2.5c0-.4-.3-.8-.8-.8" }, null, -1)
  ]))]))
}
export default { render: render }